(function() {
    $.extend(freshop.ui, {
        //documented methods
        on: function(event, selector, callback) {
            if(_.isFunction(selector)) {
                callback = selector;
                selector = undefined;
            }

            if(fp.clientUiEvents.on[event] && _.isFunction(callback)) {
                if (event == fp.events.LOADED && fp.loaded) {
                    _.defer(callback.bind(freshop.ui, $.Event(event)));
                    return this;
                }

                $(this).on(event, callback);

                if(selector) {
                    var events = $._data(freshop.ui, 'events');
                    if (events) {
                        var storedEvent = _.findWhere(events.rendered, {handler: callback});
                        if (storedEvent) storedEvent.selector = selector;
                    }
                }
            }

            return this;
        },
        off: function(event, selector, callback) {
            if(fp.clientUiEvents.on[event]) $(this).off(event, selector, callback);

            return this;
        },
        setConfig: function(config) {
            $.extend(true, fpConfig, config);
        },
        trigger: function(selector, event, data) {
            //update this to require selector when Wordpress no longer implements non-standard public Freshop events
            if(_.isString(selector) && fp.clientUiEvents.trigger[selector]) {
                data = event;
                event = selector;
                selector = undefined;
            }

            //fp.log('Trigger client event', event, fp.clientUiEvents.trigger[event], data);

            if(!fp.clientUiEvents.trigger[event]) return;

            //fp.log('Trigger client event', event, data, selector);

            return fp.trigger(event, data, selector);
        },
        getNavigation: function (storeId, onSuccess, onFailure, always) {
            if(_.isFunction(storeId)) {
                always = onFailure;
                onFailure = onSuccess;
                onSuccess = storeId;
                storeId = undefined;
            }

            var promise = fpUi.loaded()
                .then(function() {
                    return fpUi.getNavigation(S.getString(storeId));
                });

            //removeIf(!debug)

            // if(fp.disableRender) {
            //     promise = promise.then(function() {
            //         return {};
            //     });
            // }

            //endRemoveIf(!debug)

            fpUtil.applyCallback(onSuccess, onFailure, always, promise);
        },
        setStore: function(storeId, onSuccess, onFailure, always) {
            var deferred = $.Deferred();

            fp.storeChange({
                storeId: storeId,
                callback: deferred.resolve
            });

            fpUtil.applyCallback(onSuccess, onFailure, always, deferred.promise());
        },
        //new function utilizing userPreferenceService
        setFulfillmentType: function(identifier, onSuccess, onFailure, always) {
            fpUtil.applyCallback(onSuccess, onFailure, always, fpUi.setFulfillmentType(identifier));
        },
        //remove buildRoute when Wordpress implements freshop.ui.getNavigation
        buildRoute: fpUtil.getRoute.bind(fpUtil),

        //remove getSelectedListQuantity when Wordpress implements Mini List Indicator module
        getSelectedListQuantity: fpUi.ListManager.getListQuantity.bind(fpUi.ListManager),

        //remove getSelectedStore when Wordpress implements freshop.getCurrentStore
        getSelectedStore: function() {
            if(!_.isObject(fp.client.store)) fp.client.store = $.extend(true, {}, fp.store);

            return fp.client.store;
        },

        setSelectedStore: function(store) {
            fp.client.store = store;
        },

        isSingleStore: function() {
            return fp.isSingleStore;
        },

        locale: function(key, defaultVal) {
            return fp.ui.locale(key, defaultVal);
        },

        //un-documented methods
        getConfig: function() {
            return fpConfig;
        },
        getDeliveryAddress: function() {
            return _.getObject(Lockr.get('deliveryAddress'));
        },
        getLocation: function() {
            var stateManager = fpUi.router.stateManager;
            return stateManager.href(stateManager.current) || '';
        },
        renderModules: function(selector, onSuccess, onFailure, always) {
            fpUtil.applyCallback(onSuccess, onFailure, always, fpUi.renderModules(selector));
        },
        changePage: function(selector, onSuccess, onFailure, always) {
            fpUtil.applyCallback(onSuccess, onFailure, always, fpUi.changePage(selector));
        },
        getAssetCdnUrl: fpUi.getAssetCdnUrl.bind(fpUi),
        getPrefCookie: fp.getPrefCookie.bind(fp),
        setPrefCookie: fp.setPrefCookie.bind(fp),
        encodeForHtml: fpUtil.encodeForHtml.bind(fpUtil),
        decodeForHtml: fpUtil.decodeForHtml.bind(fpUtil)
    });
})();